var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 16,
    fill: "red"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9993 36.0209C9.61018 36.0209 1.97852 28.3892 1.97852 19.0001C1.97852 9.61092 9.61018 1.97925 18.9993 1.97925C28.3885 1.97925 36.0202 9.61092 36.0202 19.0001C36.0202 28.3892 28.3885 36.0209 18.9993 36.0209ZM18.9993 4.35425C10.9243 4.35425 4.35352 10.9251 4.35352 19.0001C4.35352 27.0751 10.9243 33.6459 18.9993 33.6459C27.0744 33.6459 33.6452 27.0751 33.6452 19.0001C33.6452 10.9251 27.0744 4.35425 18.9993 4.35425Z",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5195 24.6684C14.2186 24.6684 13.9178 24.5576 13.6803 24.3201C13.2211 23.8609 13.2211 23.1009 13.6803 22.6417L22.642 13.6801C23.1011 13.2209 23.8611 13.2209 24.3203 13.6801C24.7795 14.1392 24.7795 14.8992 24.3203 15.3584L15.3586 24.3201C15.137 24.5576 14.8203 24.6684 14.5195 24.6684Z",
    fill: "#E1E9EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4811 24.6684C23.1803 24.6684 22.8795 24.5576 22.642 24.3201L13.6803 15.3584C13.2211 14.8992 13.2211 14.1392 13.6803 13.6801C14.1395 13.2209 14.8995 13.2209 15.3586 13.6801L24.3203 22.6417C24.7795 23.1009 24.7795 23.8609 24.3203 24.3201C24.0828 24.5576 23.782 24.6684 23.4811 24.6684Z",
    fill: "#E1E9EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.798a67792f37e0b41629f37ddab484ac.svg";
export { ForwardRef as ReactComponent };